import React from "react";
import makeStyles from '@mui/styles/makeStyles';
import { Container } from "@mui/material";
import Grid from "@mui/material/Grid";
import UserService from "../services/UserService";
import Slider from "./Slider";

// import LanguageContext from "../LanguageContext";
// import messages from "../services/messages";
// import LiveContentCard from "./LiveContentCard";
import SectionTitle from "./SectionTitle";

const useStyles = makeStyles((theme) => ({
  root: {
    // marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  contentCard: {
    marginLeft: theme.spacing(2),
  },
  container: {
    // padding: theme.spacing(0),
  },
  title: {
    // marginLeft: theme.spacing(3),
  },
}));

export default function CarousalContainer(props) {
  const classes = useStyles();
  // const language = useContext(LanguageContext);
  let { mobile } = UserService.getUserInfo();

  return (
    <div className={classes.root}>
      <Container className={classes.container}>
        {props.title && props.title !== "" && (
          <SectionTitle icon={"icons/testimonial.svg"} title={props.title} />
        )}

        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={2}
        >
          {/* <Carousal
            videos={props.videos}
            background={props.background}
            mobile={mobile}
            userState={props.userState}
          /> */}
          <Slider
            videos={props.videos}
            mobile={mobile}
            userState={props.userState}
            userSourec={props?.userSource}
          />
        </Grid>
      </Container>
    </div>
  );
}
